import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SearchIcon, SlidersHorizontalIcon } from "lucide-react";

type Props = {
  placeholder?: string;
  color?: string;
  buttonText?: string;
  hasFilters?: boolean;
  value: string;
  onChange: (value: string) => void;
};

const SearchFilter = ({ placeholder = "Search", color = "primary", hasFilters = false, value, onChange }: Props) => {
  return (
    <div className="self-stretch flex flex-row items-start justify-start">
      <div className="flex-1 flex flex-row items-start justify-start gap-2">
        <div className="flex-1 shadow-md hover:shadow-lg rounded-lg bg-primary-foreground flex flex-row items-center justify-start py-[10px] px-[15px] gap-[12px] border-[1px] border-solid border-primary h-12">
          <SearchIcon className="text-primary" />
          <Input
            className="h-full flex-col items-start justify-start pt-1 px-0 pb-0"
            placeholder={placeholder}
            type="text"
            variant="invisible"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        {hasFilters && (
          <Button className="h-12" variant="icon" size="icon">
            <SlidersHorizontalIcon />
          </Button>
        )}
      </div>
    </div>
  );
};

export default SearchFilter;
